module.exports = __webpack_public_path__ + "img/fennu.b93cfb88.png";